import { ChangeDetectionStrategy, Component, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { FiComponentsContainer } from '@fi-app/shared/fi-components-container';
import { ISyncOnboardingEditItem, ISyncOnboarding, IOnboardingEditItem } from '../../fi-onboarding';
import { ObjectTypes } from '@fi-app/shared/types';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Component({
    selector: 'fi-onboarding-connect-edit-editor-tab',
    templateUrl: './fi-editor-tab.component.html',
    styleUrls: ['./fi-editor-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-connect-edit-editor-tab' },
    standalone: false,
    providers: [{ provide: FiComponentsContainer, useExisting: FiOnboardingConnectEditEditorTabComponent }],
})
export class FiOnboardingConnectEditEditorTabComponent extends FiComponentsContainer {
    @Input({ required: true }) onboarding: ISyncOnboardingEditItem;
    @Output() onboardingPropsChange = new EventEmitter<ISyncOnboardingEditItem>();
    @Input({ required: true }) selectedLanguageId: number;
    @Input({ required: true }) syncReadyOnboardings: INameIdObj[] = [];

    @Output() masterOnboardingChange = new EventEmitter<IOnboardingEditItem>();
    @Output() connectedOnboardingChange = new EventEmitter<IOnboardingEditItem>();

    protected readonly ObjectTypes = ObjectTypes;

    protected onOnboardingPropsChanged(): void {
        this.onboardingPropsChange.emit(this.onboarding);
    }

    onMasterOnboardingChanged($event: IOnboardingEditItem) {
        this.masterOnboardingChange.emit($event);
    }

    onConnectedOnboardingChanged($event: IOnboardingEditItem) {
        this.connectedOnboardingChange.emit($event);
    }
}
